module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan01_american-village-961e585bbcf2533a55d675ba250ea2ba.jpg";